import { render, staticRenderFns } from "./modify-info.vue?vue&type=template&id=0db4cf46&"
import script from "./modify-info.vue?vue&type=script&lang=js&"
export * from "./modify-info.vue?vue&type=script&lang=js&"
import style0 from "./modify-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports